import React, { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import Plot from 'react-plotly.js';
import { basePlotConfig, useChartTheme } from '../plotTheme';

const SocPlot = ({
  series,
  plotHeight,
}) => {
  const { mode, colors, baseLayout: makeLayout } = useChartTheme();

  // Stable props, so Plotly only redraws when the data or theme changes (redraws block the energy-flow animation)
  const data = useMemo(() => series.map((dataset, index) => ({
    x: dataset.x,
    y: dataset.y,
    type: "scatter",
    mode: "lines",
    name: `String ${index + 1}`,
    line: { color: colors.brand, width: 2, shape: "spline", smoothing: 0.6 },
    // Only shade under the first string to keep multiple strings readable
    fill: index === 0 ? "tozeroy" : "none",
    fillcolor: colors.brandFill,
  })), [series, colors]);

  const layout = useMemo(() => {
    const baseLayout = makeLayout("SOC", "%");
    return {
      ...baseLayout,
      showlegend: series.length > 1,
      yaxis: { ...baseLayout.yaxis, range: [0, 100] },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [series.length, mode]);

  return (
    <Box sx={{
      width: "100%",
      height: plotHeight,
    }}>
      <Plot
        data={data}
        layout={layout}
        config={basePlotConfig}
        useResizeHandler={true}
        style={{ width: "100%", height: "100%" }}
      />
    </Box>
  )
}

export default memo(SocPlot);
